import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { ThemeService } from '../theme/theme.service';

@Injectable({
	providedIn: 'root',
})
export class ToastService {
	constructor(private toastCtrl: ToastController, private themeService: ThemeService) {}

	async presentToast() {
		const toast = await this.toastCtrl.create({
			message: 'Your settings have been saved.',
			duration: 2000,
		});
		toast.present();
	}

	async presentToastWithOptions() {
		const toast = await this.toastCtrl.create({
			header: 'Toast header',
			message: 'Click to Close',
			position: 'top',
			buttons: [
				{
					side: 'start',
					icon: 'star',
					text: 'Favorite',
					handler: () => {
						console.log('Favorite clicked');
					},
				},
				{
					text: 'Done',
					role: 'cancel',
					handler: () => {
						console.log('Cancel clicked');
					},
				},
			],
		});
		await toast.present();

		const { role } = await toast.onDidDismiss();
		console.log('onDidDismiss resolved with role', role);
	}

	public async show(
		message: string,
		position: 'top' | 'bottom' | 'middle' = 'bottom',
		onClick?: () => void,
		onDismiss: () => void = () => {
			console.log('Toast dismissed.');
		},
		buttons: { text: string; handler?: () => void; role?: string }[] = [],
		status?: 'success' | 'warning' | 'error'
	): Promise<void> {
		try {
			// Follow the app's active theme (ThemeService honors the settings toggle
			// as well as the system preference), not the raw system media query. The
			// toast is rendered outside the routed views, so keying off the OS
			// preference alone left it light-themed inside a manually-darkened app —
			// unreadable dark text on a dark surface.
			const prefersDark = this.themeService.isDarkMode;

			// Error messages get longer duration and dismiss button
			const isError = status === 'error';
			const duration = isError ? 6000 : 3000;

			// Default button for errors to allow manual dismissal
			const defaultButtons = isError
				? [{ text: 'Dismiss', role: 'cancel' }]
				: [];

			const cssClasses = [
				'toast-custom',
				onClick ? 'clickable' : '',
				prefersDark ? 'toast-dark' : 'toast-light',
				status ? `toast-${status}` : '',
				`toast-${position}`
			].filter(Boolean);

			const toast = await this.toastCtrl.create({
				message: message,
				duration,
				position,
				translucent: true,
				buttons: buttons.length > 0 ? buttons : defaultButtons,
				cssClass: cssClasses,
			});

			if (onClick) {
				toast.addEventListener('click', (event: Event) => {
					console.log('CLICKED TOAST');
					const target = event.target as HTMLElement;
					if (!target.closest('ion-button')) {
						onClick();
						toast.dismiss();
					}
				});
			}

			toast.onWillDismiss().then(() => {
				onDismiss();
			});

			await toast.present();
		} catch (error) {
			console.error('Error showing toast:', error);
		}
	}
}
